import { TypographyVariant } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export const MARKDOWN_ELEMENT_PARAGRAPH = 'p';
export const MARKDOWN_ELEMENT_STRONG = 'strong';
export const MARKDOWN_ELEMENT_EMPHASIS = 'em';
export const MARKDOWN_ELEMENT_LINK = 'a';
export const MARKDOWN_ELEMENT_UNORDERED_LIST = 'ul';
export const MARKDOWN_ELEMENT_ORDERED_LIST = 'ol';
export const MARKDOWN_ELEMENT_LIST_ITEM = 'li';
export const MARKDOWN_ELEMENT_BLOCKQUOTE = 'blockquote';
export const MARKDOWN_ELEMENT_CODE = 'code';
export const MARKDOWN_ELEMENT_PRE = 'pre';
export const MARKDOWN_ELEMENT_HEADING_1 = 'h1';
export const MARKDOWN_ELEMENT_HEADING_2 = 'h2';
export const MARKDOWN_ELEMENT_HEADING_3 = 'h3';
export const MARKDOWN_ELEMENT_HEADING_4 = 'h4';
export const MARKDOWN_ELEMENT_HEADING_5 = 'h5';
export const MARKDOWN_ELEMENT_HEADING_6 = 'h6';

export const MARKDOWN_LINK_TARGET = '_blank';
export const MARKDOWN_LINK_REL = 'noopener noreferrer';

export const MARKDOWN_PARAGRAPH_SX: SxProps<Theme> = {
  mb: 1,
  mt: 0,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

export const MARKDOWN_LIST_SX: SxProps<Theme> = {
  marginBottom: 1,
  marginTop: 1,
  paddingLeft: 3,
};

export const MARKDOWN_LIST_ITEM_SX: SxProps<Theme> = {
  marginBottom: 0.5,
  '&:last-of-type': {
    marginBottom: 0,
  },
};

export const MARKDOWN_BLOCKQUOTE_SX: SxProps<Theme> = {
  borderLeft: (theme) => `4px solid ${theme.palette.divider}`,
  margin: 0,
  paddingLeft: 2,
};

export const MARKDOWN_INLINE_CODE_SX: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.action.hover,
  borderRadius: 1,
  fontFamily: 'monospace',
  padding: '0 4px',
};

export const MARKDOWN_CODE_BLOCK_SX: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.action.hover,
  borderRadius: 1,
  fontFamily: 'monospace',
  marginBottom: 2,
  marginTop: 1,
  overflowX: 'auto',
  padding: 2,
};

export const MARKDOWN_HEADING_VARIANT_MAP: Record<string, TypographyVariant> = {
  [MARKDOWN_ELEMENT_HEADING_1]: 'h5',
  [MARKDOWN_ELEMENT_HEADING_2]: 'h6',
  [MARKDOWN_ELEMENT_HEADING_3]: 'subtitle1',
  [MARKDOWN_ELEMENT_HEADING_4]: 'subtitle2',
  [MARKDOWN_ELEMENT_HEADING_5]: 'body1',
  [MARKDOWN_ELEMENT_HEADING_6]: 'body2',
};
